import React from 'react';

export const EmptyQAIcon: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='136'
    height='137'
    fill='none'
    viewBox='0 0 136 137'
  >
    <path
      fill='var(--stroke)'
      fillRule='evenodd'
      d='M18.244 97h23.223v-9.5h-7.534l7.885-7.88-2.992-3.349c-4.484-5.025-6.86-11.001-6.86-17.271 0-15.718 14.916-28.5 33.25-28.5 16.588 0 30.757 10.611 32.956 24.686l9.386-1.463C104.642 35.065 86.44 21 65.217 21c-23.57 0-42.75 17.048-42.75 38 0 7.196 2.223 14.055 6.464 20.073L16.123 91.879c-1.89 1.89-.552 5.122 2.121 5.122zm97.74 23.75c2.396 0 3.825-2.67 2.496-4.664l-8.324-12.488a26.609 26.609 0 002.56-11.348c0-15.718-13.85-28.5-30.875-28.5-17.024 0-30.875 12.782-30.875 28.5s13.851 28.5 30.875 28.5h34.143zm-55.518-28.5c0-10.474 9.59-19 21.375-19 11.79 0 21.375 8.526 21.375 19 0 3.22-.883 6.284-2.631 9.106l-1.606 2.593 4.864 7.301H81.841c-11.784 0-21.375-8.521-21.375-19z'
      clipRule='evenodd'
    ></path>
  </svg>
);
